// Mantine
import { Anchor } from '@mantine/core'

// Next
import { Link } from 'react-router-dom'

// UI
import Box from '@/components/ui/Box'
import SKU from '@/components/ui/SKU'

export default function ProductionOrderChildrenBlock(productionOrder) {
    const children = [...productionOrder.component.children].sort((a, b) => {
        return a.component_category.name_fr.localeCompare(
            b.component_category.name_fr
        )
    })

    return (
        <Box
            className="p-5 bg-white border rounded-sm flex flex-col gap-3"
            title="Composants utilisés dans l'assemblage"
            subtitle={
                "Stock à l'emplacement : " + productionOrder.location.name
            }
        >
            <div className="flex flex-col border rounded-sm rounded-xl">
                {children.map((component) => {
                    const full_name_fr =
                        component.component_category.name_fr +
                        ' — ' +
                        component.name

                    const invlevel = component.invlevels.find(
                        (invlevel) =>
                            invlevel.location_id === productionOrder.location_id
                    )?.invlevel

                    return (
                        <div
                            className="flex items-center justify-between px-2 py-2 even:bg-gray-100"
                            key={component.id}
                        >
                            <div className="flex items-center gap-2">
                                <span className="text-gray-700">
                                    ×{component.pivot.quantity}
                                </span>

                                <SKU component={component} size="sm" />

                                <Link to={`/components/${component.id}`}>
                                    <Anchor component="span">{full_name_fr}</Anchor>
                                </Link>
                            </div>

                            {invlevel !== undefined && (
                                <span className="text-gray-500 text-sm ml-auto">
                                    {Intl.NumberFormat('fr-FR').format(
                                        invlevel
                                    )}{' '}
                                    en stock
                                </span>
                            )}

                            {invlevel === undefined && (
                                <span className="text-gray-500 text-sm ml-auto">
                                    Non stocké
                                </span>
                            )}
                        </div>
                    )
                })}
            </div>
        </Box>
    )
}
